import { createFileRoute, useRouter } from '@tanstack/react-router';
import { useMediaQuery } from 'react-responsive';
import { useQuery } from '@apollo/client';
import Modal from 'src/components/ui/Modal';
import CourseViewDialog from 'src/components/ui/CourseInfoDialog';
import COURSE_QUERY from 'src/graphql/query/course.graphql';

import { useMemo } from 'react';

import type { Course } from 'src/types/course';

const ShortView = () => {
  const { courseId } = Route.useParams();
  const { history, navigate } = useRouter();

  const isMobile = useMediaQuery({
    query: '(max-width: 768px)',
  });

  const size = isMobile ? 'small' : 'medium';

  const { data, loading } = useQuery(COURSE_QUERY, {
    variables: { id: courseId },
  });

  const materialId = useMemo(
    () => Number(data?.course?.courseMaterials[0]?.courseMaterialId),
    [data?.course?.courseMaterials]
  );

  if (loading) return null;

  return (
    <Modal
      size={size}
      defaultOpen
      isKeyboardDismissDisabled
      onOpenChange={(open) => {
        if (!open) {
          history.back();
        }
      }}
    >
      <CourseViewDialog
        course={data.course as Course}
        onView={() =>
          navigate({
            to: `/courses/$courseId/details`,
            params: { courseId },
          })
        }
        onRead={() =>
          navigate({
            to: `/courses/$courseId`,
            params: { courseId },
            search: { materialId },
          })
        }
        size={size}
      />
    </Modal>
  );
};

export const Route = createFileRoute(
  '/_authenticated/_layout-advanced/courses/$courseId/short-view'
)({
  component: ShortView,
});
